import { render, staticRenderFns } from "./LeadFormsWrapper.vue?vue&type=template&id=2d97f55e&"
import script from "./LeadFormsWrapper.vue?vue&type=script&lang=ts&"
export * from "./LeadFormsWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports